import React, {useContext, useEffect, useState} from 'react';
import RightDrawer from "../../../../../../../components/WMS/Mobile/RightDrawer";
import {FormattedMessage} from "react-intl";
import WmsMobileLayout from "../../../../../wmsMobileLayout";
import CustomButton from "../../../../../../../components/CustomButton";
import {BarCodeScannerContext} from "../../../../../../../contexts/barCodeScannerContext";
import {Grid} from "@mui/material";
import {WmsContainerType} from "../../../../../../../utils/WMSContainerType";
import PropTypes from "prop-types";
import DisplayItemList from "./components/DisplayItemList";
import SortSingleTrolleyHeader from "./components/SortSingleTrolleyHeader";
import {WMSContext} from "../../../../../context/WMSContext";
import _ from 'lodash';
import FullTransfer from "../../../../../../../components/WMS/MassTransfert/FullTransfer";
import ScanFinishContent from "./components/ScanFinishContent";
import StackTransfer from "./StackTransfer";
import {SortingContext} from "../../../SortingContext";
import DrawerHeaderMenu from "../../DrawerHeaderMenu";


ToBeSortedSingleTrolley.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    isScanFinish: PropTypes.bool.isRequired,
    handleArticleSelected: PropTypes.func.isRequired,
    handleCloseFullTransferModal: PropTypes.func.isRequired,
    goBackToSorting: PropTypes.func.isRequired,
    selectedRetailer: PropTypes.object,
};

function ToBeSortedSingleTrolley({open, handleClose, isScanFinish, handleArticleSelected, handleCloseFullTransferModal, goBackToSorting, selectedRetailer = null}) {

    const { setEnableScan} = useContext(BarCodeScannerContext)
    const {currentMember} = useContext(WMSContext)
    const {
        selectedContainer,
        selectedContainerIndex,
        refreshTrolley,
        massTransfer,
        massTransferToStack,
        inSorting,
        setInSorting,
        isScanned,
        handleStartSorting,
    } = useContext(SortingContext)

    const [currentContainer, setCurrentContainer] = useState()




    const handleGroupDisplayedItem = (toBeGroupedTrolley) => {
        let tempTrolley = toBeGroupedTrolley
        tempTrolley.itemCount = 0
        const items = [...tempTrolley.wmsItems]
        let groupedItems = []

        const processItem = (item) => {
            const foundItem = groupedItems.find(groupedItem => item.lineItem.variationSku === groupedItem.lineItem.variationSku)

            if (foundItem) {
                foundItem.count++
                tempTrolley.itemCount++
                if (foundItem.lineItem.currentShipment.multi !== item.lineItem.currentShipment.multi) {
                    foundItem.shipmentType = <FormattedMessage id={"wms.sorting.monoAndMulti"}/>
                }
            } else {
                tempTrolley.itemCount++
                item.count = 1
                item.shipmentType = item.lineItem.currentShipment.multi
                    ? <FormattedMessage id={"wms.sorting.multi"}/>
                    : <FormattedMessage id={"wms.sorting.mono"}/>
                groupedItems.push(item)
            }
        }

        items.filter(i => i.lineItem.currentShipment.multi).forEach(processItem)
        items.filter(i => !i.lineItem.currentShipment.multi).forEach(processItem)

        tempTrolley.wmsItems = groupedItems

        return tempTrolley
    }

    const handleGroupedItems = (container) => {
        if (container && container.wmsItems.length > 0) {
            let groupedTrolley = _.cloneDeep(container)
            if (selectedRetailer) {
                groupedTrolley.wmsItems = groupedTrolley.wmsItems.filter(
                    item => item.retailer?.id === selectedRetailer.id
                )
            }
            groupedTrolley = handleGroupDisplayedItem(groupedTrolley)

            setCurrentContainer(groupedTrolley)
        } else {
            setCurrentContainer({
                ...currentContainer,
                wmsItems: []
            })
        }
    }

    useEffect(() => {
        if (!selectedContainer || !currentMember) {
            return;
        }

        if (selectedContainer.member && selectedContainer.member.id && selectedContainer.member.id === currentMember.id) {
            setInSorting(true);
        }
    }, [selectedContainer, currentMember])

// IF TROLLEY WAS SCANNED
    useEffect(() => {
        if (isScanned && currentContainer) {
            handleStartSorting()
        }
    }, [isScanned, currentContainer]);

    useEffect(() => {
        if (selectedContainer) {
            handleGroupedItems(selectedContainer)
        }
    }, [selectedContainer, selectedRetailer]);

// WHEN SCANNING


    return (
        <RightDrawer
            open={open}
            handleClose={handleClose}
            headerLeftContent={(
                <b style={{marginLeft: '16px', fontSize: '16px'}}>
                    {selectedContainer.name ?? selectedContainerIndex}
                </b>
            )}
            headerRightContent={<DrawerHeaderMenu itemCount={currentContainer?.itemCount} />}
        >
            <WmsMobileLayout disableMargin fitParent>
                <WmsMobileLayout.Content>
                    {isScanFinish === false ? (
                        <>
                            <SortSingleTrolleyHeader
                                isInSorting={inSorting}
                                containerName={selectedContainer.name}
                                containerIndex={selectedContainerIndex}
                            />
                            {currentContainer && (
                                <DisplayItemList
                                    currentContainer={currentContainer}
                                    refreshTrolley={() => refreshTrolley(selectedContainer)}
                                    inSorting={inSorting}
                                    onManualValidate={handleArticleSelected}
                                />
                            )}
                        </>
                    ) : (
                        <ScanFinishContent goBackToSorting={goBackToSorting}/>
                    )}
                </WmsMobileLayout.Content>
                <WmsMobileLayout.Footer>
                    <Grid container flexWrap={'nowrap'}>
                        {isScanFinish === false && !inSorting && currentContainer && (
                            <CustomButton onClick={() => handleStartSorting(currentContainer)} fullWidth>
                                <FormattedMessage id={"wms.sorting.containerPeek.button"} values={{containerName: currentContainer.name}}/>
                            </CustomButton>
                        )}
                        {isScanFinish === false && massTransfer && inSorting && (
                            <FullTransfer
                                handleIsValid={(doRefresh) => handleCloseFullTransferModal(doRefresh)}
                                currentContainer={selectedContainer}
                                inSorting={inSorting}
                                toContainers={[
                                    WmsContainerType.SHELF
                                ]}
                            />
                        )}
                        {isScanFinish === false && massTransferToStack && inSorting && currentContainer && currentContainer.type !== WmsContainerType.STACK && (
                            <StackTransfer
                                currentContainer={currentContainer}
                                handleIsValid={(doRefresh) => handleCloseFullTransferModal(doRefresh)}
                                fullWidth={!massTransfer}
                                onPopupOpenChange={(isOpen) => setEnableScan(!isOpen)}
                            />
                        )}
                    </Grid>
                </WmsMobileLayout.Footer>

            </WmsMobileLayout>
        </RightDrawer>
    );
}

export default ToBeSortedSingleTrolley;
